// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file sm/simulation_manager.proto (package vsmr.sm.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * ------------------------------------------------------------
 * StartMode
 *
 * Controls whether SM starts the simulation right after Build.
 * The adapter is not told; SM records the mode and acts on it.
 * ------------------------------------------------------------
 *
 * @generated from enum vsmr.sm.v1.StartMode
 */
export enum StartMode {
  /**
   * SM starts the simulation after Build when any task is AUTO (default).
   *
   * @generated from enum value: START_MODE_AUTO = 0;
   */
  AUTO = 0,

  /**
   * SM does not start it; the client calls SimulationControl.Start.
   *
   * @generated from enum value: START_MODE_MANUAL = 1;
   */
  MANUAL = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(StartMode)
proto3.util.setEnumType(StartMode, "vsmr.sm.v1.StartMode", [
  { no: 0, name: "START_MODE_AUTO" },
  { no: 1, name: "START_MODE_MANUAL" },
]);

/**
 * ------------------------------------------------------------
 * SimulationStatus
 *
 * Simulation-level state machine. The one declaration of the state
 * vocabulary: SimulationControl replies (SimulationState), the session
 * snapshot (SessionSimulationState) and the state notice (TaskStateChanged)
 * all carry this enum, and SM derives its own state type from it.
 *
 *   BUILDING → RUNNING ↔ PAUSED → COMPLETED/STOPPED   (auto start)
 *   BUILDING → READY → RUNNING ↔ PAUSED → …            (manual start)
 * BUILDING means the Build has not succeeded yet: an auto-start simulation stays
 * BUILDING until its Start is accepted; READY only means "built, waiting for a
 * manual Start".
 * ------------------------------------------------------------
 *
 * @generated from enum vsmr.sm.v1.SimulationStatus
 */
export enum SimulationStatus {
  /**
   * @generated from enum value: SIMULATION_STATUS_BUILDING = 0;
   */
  BUILDING = 0,

  /**
   * @generated from enum value: SIMULATION_STATUS_READY = 1;
   */
  READY = 1,

  /**
   * @generated from enum value: SIMULATION_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: SIMULATION_STATUS_PAUSED = 3;
   */
  PAUSED = 3,

  /**
   * @generated from enum value: SIMULATION_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * @generated from enum value: SIMULATION_STATUS_STOPPED = 5;
   */
  STOPPED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(SimulationStatus)
proto3.util.setEnumType(SimulationStatus, "vsmr.sm.v1.SimulationStatus", [
  { no: 0, name: "SIMULATION_STATUS_BUILDING" },
  { no: 1, name: "SIMULATION_STATUS_READY" },
  { no: 2, name: "SIMULATION_STATUS_RUNNING" },
  { no: 3, name: "SIMULATION_STATUS_PAUSED" },
  { no: 4, name: "SIMULATION_STATUS_COMPLETED" },
  { no: 5, name: "SIMULATION_STATUS_STOPPED" },
]);

/**
 * ------------------------------------------------------------
 * SimulationId
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SimulationId
 */
export class SimulationId extends Message<SimulationId> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  constructor(data?: PartialMessage<SimulationId>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SimulationId";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SimulationId {
    return new SimulationId().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SimulationId {
    return new SimulationId().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SimulationId {
    return new SimulationId().fromJsonString(jsonString, options);
  }

  static equals(a: SimulationId | PlainMessage<SimulationId> | undefined, b: SimulationId | PlainMessage<SimulationId> | undefined): boolean {
    return proto3.util.equals(SimulationId, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SessionId
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SessionId
 */
export class SessionId extends Message<SessionId> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  constructor(data?: PartialMessage<SessionId>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SessionId";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionId {
    return new SessionId().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionId {
    return new SessionId().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionId {
    return new SessionId().fromJsonString(jsonString, options);
  }

  static equals(a: SessionId | PlainMessage<SessionId> | undefined, b: SessionId | PlainMessage<SessionId> | undefined): boolean {
    return proto3.util.equals(SessionId, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * TaskId
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.TaskId
 */
export class TaskId extends Message<TaskId> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  constructor(data?: PartialMessage<TaskId>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.TaskId";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskId {
    return new TaskId().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskId {
    return new TaskId().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskId {
    return new TaskId().fromJsonString(jsonString, options);
  }

  static equals(a: TaskId | PlainMessage<TaskId> | undefined, b: TaskId | PlainMessage<TaskId> | undefined): boolean {
    return proto3.util.equals(TaskId, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * DeleteTaskRequest
 *
 * DeleteTask 는 **어댑터가 스스로** 부르는 콜백이다. 그런데 어댑터는 정상 완료와
 * 실패(예: 엔진 서브프로세스 SIGSEGV) 모두에서 이것을 부르기 때문에, 제어면은 둘을
 * 구분할 수 없었다. 2026-08-19 50 동시 시험에서 MARS 엔진이 죽었는데 지표상으로는
 * sm_builds_total{success}=50 뿐이었고 실패 카운터는 움직이지 않았다 — 크래시를
 * 알아챈 것은 파드가 사라진 뒤 로그를 뒤져서였다(mars-adapter#97).
 *
 * 그래서 어댑터가 판정한 종료 사유를 실어 보낸다.
 *
 * ⚠️ 와이어 호환: field 1(task_id, string)이 TaskId 와 같은 번호·타입이므로, 구
 *    어댑터가 보내던 TaskId 바이트가 이 메시지로 그대로 파싱된다. 이미지 롤아웃
 *    순서에 무관하게 동작한다. 구 어댑터는 final_state 를 보내지 않으므로
 *    FINAL_STATE_UNSPECIFIED 로 들어온다 — '모르는 것' 이지 '정상' 이 아니다.
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.DeleteTaskRequest
 */
export class DeleteTaskRequest extends Message<DeleteTaskRequest> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: vsmr.sm.v1.DeleteTaskRequest.FinalState final_state = 2;
   */
  finalState = DeleteTaskRequest_FinalState.FINAL_STATE_UNSPECIFIED;

  /**
   * 사람이 읽을 짧은 사유. 예: "server subprocess rc=-11".
   * 지표 라벨로는 쓰지 않는다(카디널리티). SM 의 실패 로그에만 남는다.
   *
   * @generated from field: string detail = 3;
   */
  detail = "";

  constructor(data?: PartialMessage<DeleteTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.DeleteTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "final_state", kind: "enum", T: proto3.getEnumType(DeleteTaskRequest_FinalState) },
    { no: 3, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTaskRequest {
    return new DeleteTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTaskRequest {
    return new DeleteTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTaskRequest {
    return new DeleteTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTaskRequest | PlainMessage<DeleteTaskRequest> | undefined, b: DeleteTaskRequest | PlainMessage<DeleteTaskRequest> | undefined): boolean {
    return proto3.util.equals(DeleteTaskRequest, a, b);
  }
}

/**
 * 어댑터가 판정한 태스크의 최종 상태.
 *
 * @generated from enum vsmr.sm.v1.DeleteTaskRequest.FinalState
 */
export enum DeleteTaskRequest_FinalState {
  /**
   * 구 어댑터이거나 판정 불가 — 정상으로 뭉개지 않는다.
   * 제로값에 접두사를 붙이는 것은 같은 파일 TaskEnded.Cause 의 관례를 따른 것이다.
   *
   * @generated from enum value: FINAL_STATE_UNSPECIFIED = 0;
   */
  FINAL_STATE_UNSPECIFIED = 0,

  /**
   * 시뮬레이션이 끝까지 돌고 결과를 올린 뒤 종료.
   *
   * @generated from enum value: COMPLETED = 1;
   */
  COMPLETED = 1,

  /**
   * 어댑터가 실패로 끝냄 (엔진 비정상 종료, 초기화 실패 등).
   *
   * @generated from enum value: FAILED = 2;
   */
  FAILED = 2,

  /**
   * 사용자 정지 요청으로 끝냄 — 완주(COMPLETED)와 구분한다. 정지 요청이
   * 커플링 창 소진과 겹친 경계는 어댑터가 판정한다(창 소진이면 COMPLETED).
   *
   * @generated from enum value: STOPPED = 3;
   */
  STOPPED = 3,

  /**
   * SM 이 붙이는 값 — 어댑터의 보고도, 잡 래퍼가 K8s 종료 메시지에 남긴 판정도 없이 Job 이
   * 사라졌거나 끝났다(실패의 증거도 없다). «죽은 Job» 회수가 판정 없이 정리했다(결과는 모른다).
   * SM 은 들고 있는 태스크의 Job 을 지우지 않으므로 사라진 Job 은 SM 바깥에서 지운 것이다.
   * 어댑터는 이 값을 보내지 않는다; DeleteTask 로 오면 INVALID_ARGUMENT.
   *
   * @generated from enum value: TERMINATED = 4;
   */
  TERMINATED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(DeleteTaskRequest_FinalState)
proto3.util.setEnumType(DeleteTaskRequest_FinalState, "vsmr.sm.v1.DeleteTaskRequest.FinalState", [
  { no: 0, name: "FINAL_STATE_UNSPECIFIED" },
  { no: 1, name: "COMPLETED" },
  { no: 2, name: "FAILED" },
  { no: 3, name: "STOPPED" },
  { no: 4, name: "TERMINATED" },
]);

/**
 * ------------------------------------------------------------
 * SessionEventsRequest
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SessionEventsRequest
 */
export class SessionEventsRequest extends Message<SessionEventsRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * Replay retained events with seq > after_seq (0 replays all retained).
   *
   * @generated from field: uint64 after_seq = 2;
   */
  afterSeq = protoInt64.zero;

  /**
   * The log generation the cursor belongs to (SessionEvent.log_epoch of the
   * last event seen). The log is per replica process: after a reconstruction
   * or adoption the session's log starts over at seq 1 on another process, so
   * a seq from the old log is meaningless there. When after_epoch differs
   * from the current log's epoch, after_seq is ignored and everything retained
   * is replayed. 0 = cursor without a generation (legacy client) → after_seq
   * is honoured as before.
   *
   * @generated from field: uint64 after_epoch = 3;
   */
  afterEpoch = protoInt64.zero;

  constructor(data?: PartialMessage<SessionEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SessionEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "after_seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "after_epoch", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionEventsRequest {
    return new SessionEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionEventsRequest {
    return new SessionEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionEventsRequest {
    return new SessionEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SessionEventsRequest | PlainMessage<SessionEventsRequest> | undefined, b: SessionEventsRequest | PlainMessage<SessionEventsRequest> | undefined): boolean {
    return proto3.util.equals(SessionEventsRequest, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * TaskEnded
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.TaskEnded
 */
export class TaskEnded extends Message<TaskEnded> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * @generated from field: string task_id = 2;
   */
  taskId = "";

  /**
   * @generated from field: vsmr.sm.v1.TaskEnded.Cause cause = 3;
   */
  cause = TaskEnded_Cause.CAUSE_UNSPECIFIED;

  /**
   * True when this teardown emptied the simulation (it was removed).
   *
   * @generated from field: bool sim_removed = 4;
   */
  simRemoved = false;

  /**
   * 판정된 최종 상태 — DELETE_TASK 는 어댑터 보고 그대로(모르면 UNSPECIFIED),
   * DEAD_JOB 은 잡 래퍼가 K8s 종료 메시지에 남긴 판정이 있으면 그것, 없으면 SM 이 Job 증거로
   * 가른 값(Job Failed → FAILED, 그 밖 → TERMINATED).
   * 수신자는 이 값을 그대로 반영한다 — cause 로 상태를 추측하지 않는다
   * (실행 상태 권위 설계 P4: 통지는 사실만 나른다).
   *
   * @generated from field: vsmr.sm.v1.DeleteTaskRequest.FinalState final_state = 5;
   */
  finalState = DeleteTaskRequest_FinalState.FINAL_STATE_UNSPECIFIED;

  /**
   * 어댑터가 DeleteTaskRequest.detail 로 보고한 실패 사유 원문. DEAD_JOB 은 종료 메시지의
   * 판정이 있으면 그 사유, 없으면 SM 이 Job 증거를 싣는다 — Failed 면 «job failed: <파드가 끝나며
   * 남긴 것(컨테이너 종료 코드·사유·종료 메시지)> — <Job 조건>», 그 밖은 빈 값. 비어 있을 수
   * 있다 — 구 어댑터이거나 증거가 없는 경로다. 빈 값을 "정상"으로 읽으면 안 된다.
   *
   * cause 와 겹치지 않는다: cause 는 "누가 걷어냈나"(제어 평면의 트리거),
   * detail 은 "무엇이 잘못됐나"(어댑터가 관측한 사실)다. 2026-08-22 50 동시
   * 시험에서 이 필드가 없어서, SM 이 0.4초 만에 알아낸
   * "server subprocess -11 (signal SIGSEGV)" 가 로그에만 남고 클라이언트는
   * 30분 뒤 "not found in session" 만 받았다.
   *
   * ⚠️ 중계자(BFF)는 이 필드를 아는 스텁으로 다시 생성해야 한다. connectrpc 의
   * JSON 인코딩은 MessageToJson 이라 **모르는 필드를 조용히 버린다**(실측).
   * 바이트 릴레이와 달리 unknown field 가 보존되지 않는다.
   *
   * @generated from field: string detail = 6;
   */
  detail = "";

  constructor(data?: PartialMessage<TaskEnded>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.TaskEnded";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cause", kind: "enum", T: proto3.getEnumType(TaskEnded_Cause) },
    { no: 4, name: "sim_removed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "final_state", kind: "enum", T: proto3.getEnumType(DeleteTaskRequest_FinalState) },
    { no: 6, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskEnded {
    return new TaskEnded().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskEnded {
    return new TaskEnded().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskEnded {
    return new TaskEnded().fromJsonString(jsonString, options);
  }

  static equals(a: TaskEnded | PlainMessage<TaskEnded> | undefined, b: TaskEnded | PlainMessage<TaskEnded> | undefined): boolean {
    return proto3.util.equals(TaskEnded, a, b);
  }
}

/**
 * Why the control plane tore the task down.
 *
 * @generated from enum vsmr.sm.v1.TaskEnded.Cause
 */
export enum TaskEnded_Cause {
  /**
   * @generated from enum value: CAUSE_UNSPECIFIED = 0;
   */
  CAUSE_UNSPECIFIED = 0,

  /**
   * Adapter-initiated DeleteTask — the normal end-of-run path.
   *
   * @generated from enum value: DELETE_TASK = 1;
   */
  DELETE_TASK = 1,

  /**
   * Reserved — SM no longer sends it: the force-teardown timer after Stop
   * is gone (SM times nothing after Stop). Kept for wire compatibility.
   *
   * @generated from enum value: FORCE_TIMER = 2;
   */
  FORCE_TIMER = 2,

  /**
   * Dead-task reap: the task's K8s Job finished or vanished without the
   * adapter's DeleteTask ever arriving (crash, kill, lost callback) — the
   * periodic sweep reconciled the registry against K8s reality.
   *
   * @generated from enum value: DEAD_JOB = 3;
   */
  DEAD_JOB = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskEnded_Cause)
proto3.util.setEnumType(TaskEnded_Cause, "vsmr.sm.v1.TaskEnded.Cause", [
  { no: 0, name: "CAUSE_UNSPECIFIED" },
  { no: 1, name: "DELETE_TASK" },
  { no: 2, name: "FORCE_TIMER" },
  { no: 3, name: "DEAD_JOB" },
]);

/**
 * ------------------------------------------------------------
 * TaskStateChanged
 *
 * 비종결 전이의 제어 평면 통지 — Pause/Resume 팬아웃이 성공한 시점에
 * 발신한다(전부-아니면-롤백이라 성공 = 사실 확정). 요청자 자신은 RPC
 * 응답으로 이미 알고 있으므로, 이 통지의 수신자는 같은 실행을 보는
 * 다른 세션(공동 관찰자·다른 탭)이다.
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.TaskStateChanged
 */
export class TaskStateChanged extends Message<TaskStateChanged> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * @generated from field: vsmr.sm.v1.SimulationStatus status = 3;
   */
  status = SimulationStatus.BUILDING;

  constructor(data?: PartialMessage<TaskStateChanged>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.TaskStateChanged";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(SimulationStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskStateChanged {
    return new TaskStateChanged().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskStateChanged {
    return new TaskStateChanged().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskStateChanged {
    return new TaskStateChanged().fromJsonString(jsonString, options);
  }

  static equals(a: TaskStateChanged | PlainMessage<TaskStateChanged> | undefined, b: TaskStateChanged | PlainMessage<TaskStateChanged> | undefined): boolean {
    return proto3.util.equals(TaskStateChanged, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SessionEvent
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SessionEvent
 */
export class SessionEvent extends Message<SessionEvent> {
  /**
   * Per-session monotonic sequence — resume/dedup key for subscribers.
   *
   * @generated from field: uint64 seq = 1;
   */
  seq = protoInt64.zero;

  /**
   * @generated from field: int64 wall_time_ms = 2;
   */
  wallTimeMs = protoInt64.zero;

  /**
   * Generation of the session's event log (per replica process; a new value
   * after reconstruction/adoption). Subscribers key their cursor on
   * (log_epoch, seq): a different epoch means "the log started over" — reset
   * the cursor to 0 and apply from this event. Never 0 (0 = "no generation"
   * on the request side); always below 2^53 so a JavaScript number round-trips
   * it exactly. Relays that re-encode this message (BFF Connect
   * JSON) must be built from stubs that know this field — MessageToJson
   * drops unknown fields silently, on this and on after_epoch alike.
   *
   * @generated from field: uint64 log_epoch = 5;
   */
  logEpoch = protoInt64.zero;

  /**
   * @generated from oneof vsmr.sm.v1.SessionEvent.event
   */
  event: {
    /**
     * @generated from field: vsmr.sm.v1.TaskEnded task_ended = 3;
     */
    value: TaskEnded;
    case: "taskEnded";
  } | {
    /**
     * @generated from field: vsmr.sm.v1.TaskStateChanged task_state_changed = 4;
     */
    value: TaskStateChanged;
    case: "taskStateChanged";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SessionEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SessionEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "wall_time_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "log_epoch", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "task_ended", kind: "message", T: TaskEnded, oneof: "event" },
    { no: 4, name: "task_state_changed", kind: "message", T: TaskStateChanged, oneof: "event" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionEvent {
    return new SessionEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionEvent {
    return new SessionEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionEvent {
    return new SessionEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SessionEvent | PlainMessage<SessionEvent> | undefined, b: SessionEvent | PlainMessage<SessionEvent> | undefined): boolean {
    return proto3.util.equals(SessionEvent, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SessionSimulationState
 *
 * Registry-level snapshot of one simulation inside a session. Pacing and
 * progress time live in the adapters; query them per sim via
 * SimulationControl.GetState / GetSimulationSpeed.
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SessionSimulationState
 */
export class SessionSimulationState extends Message<SessionSimulationState> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * "single" | "cosim"
   *
   * @generated from field: string sim_type = 2;
   */
  simType = "";

  /**
   * @generated from field: vsmr.sm.v1.SimulationStatus status = 5;
   */
  status = SimulationStatus.BUILDING;

  /**
   * @generated from field: repeated vsmr.sm.v1.TaskInfo tasks = 4;
   */
  tasks: TaskInfo[] = [];

  constructor(data?: PartialMessage<SessionSimulationState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SessionSimulationState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sim_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(SimulationStatus) },
    { no: 4, name: "tasks", kind: "message", T: TaskInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionSimulationState {
    return new SessionSimulationState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionSimulationState {
    return new SessionSimulationState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionSimulationState {
    return new SessionSimulationState().fromJsonString(jsonString, options);
  }

  static equals(a: SessionSimulationState | PlainMessage<SessionSimulationState> | undefined, b: SessionSimulationState | PlainMessage<SessionSimulationState> | undefined): boolean {
    return proto3.util.equals(SessionSimulationState, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SessionState
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SessionState
 */
export class SessionState extends Message<SessionState> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * True while at least one liveness stream is connected. False
   * means the idle-reclaim clock is running (see AttachSession).
   *
   * @generated from field: bool attached = 2;
   */
  attached = false;

  /**
   * @generated from field: repeated vsmr.sm.v1.SessionSimulationState simulations = 3;
   */
  simulations: SessionSimulationState[] = [];

  constructor(data?: PartialMessage<SessionState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SessionState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attached", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "simulations", kind: "message", T: SessionSimulationState, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionState {
    return new SessionState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionState {
    return new SessionState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionState {
    return new SessionState().fromJsonString(jsonString, options);
  }

  static equals(a: SessionState | PlainMessage<SessionState> | undefined, b: SessionState | PlainMessage<SessionState> | undefined): boolean {
    return proto3.util.equals(SessionState, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SessionStateList
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SessionStateList
 */
export class SessionStateList extends Message<SessionStateList> {
  /**
   * @generated from field: repeated vsmr.sm.v1.SessionState sessions = 1;
   */
  sessions: SessionState[] = [];

  constructor(data?: PartialMessage<SessionStateList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SessionStateList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sessions", kind: "message", T: SessionState, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionStateList {
    return new SessionStateList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionStateList {
    return new SessionStateList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionStateList {
    return new SessionStateList().fromJsonString(jsonString, options);
  }

  static equals(a: SessionStateList | PlainMessage<SessionStateList> | undefined, b: SessionStateList | PlainMessage<SessionStateList> | undefined): boolean {
    return proto3.util.equals(SessionStateList, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * AddTaskRequest
 *
 * Request to add a task to a simulation being built.
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.AddTaskRequest
 */
export class AddTaskRequest extends Message<AddTaskRequest> {
  /**
   * Simulation to add the task to.
   *
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * Task type / engine identifier (e.g. "mars").
   *
   * @generated from field: string task_type = 2;
   */
  taskType = "";

  /**
   * Command-line style arguments for the task.
   *
   * @generated from field: repeated string args = 3;
   */
  args: string[] = [];

  /**
   * Start mode for the task (default: AUTO).
   *
   * @generated from field: vsmr.sm.v1.StartMode start_mode = 4;
   */
  startMode = StartMode.AUTO;

  constructor(data?: PartialMessage<AddTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.AddTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "args", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "start_mode", kind: "enum", T: proto3.getEnumType(StartMode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddTaskRequest {
    return new AddTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddTaskRequest {
    return new AddTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddTaskRequest {
    return new AddTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddTaskRequest | PlainMessage<AddTaskRequest> | undefined, b: AddTaskRequest | PlainMessage<AddTaskRequest> | undefined): boolean {
    return proto3.util.equals(AddTaskRequest, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * BuildRequest
 *
 * Request to materialize a simulation.
 * For co-simulation, shared_configs provides S3 URIs for
 * files shared across all tasks (e.g. precice-config.xml).
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.BuildRequest
 */
export class BuildRequest extends Message<BuildRequest> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * S3 URIs of shared configuration files.
   *
   * @generated from field: repeated string shared_configs = 2;
   */
  sharedConfigs: string[] = [];

  constructor(data?: PartialMessage<BuildRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.BuildRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shared_configs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BuildRequest {
    return new BuildRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BuildRequest {
    return new BuildRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BuildRequest {
    return new BuildRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BuildRequest | PlainMessage<BuildRequest> | undefined, b: BuildRequest | PlainMessage<BuildRequest> | undefined): boolean {
    return proto3.util.equals(BuildRequest, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * TaskInfo
 *
 * Snapshot-style metadata of a task.
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.TaskInfo
 */
export class TaskInfo extends Message<TaskInfo> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: string task_type = 2;
   */
  taskType = "";

  constructor(data?: PartialMessage<TaskInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.TaskInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskInfo {
    return new TaskInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskInfo {
    return new TaskInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskInfo {
    return new TaskInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TaskInfo | PlainMessage<TaskInfo> | undefined, b: TaskInfo | PlainMessage<TaskInfo> | undefined): boolean {
    return proto3.util.equals(TaskInfo, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SimulationInfo
 *
 * Snapshot-style metadata of a simulation.
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SimulationInfo
 */
export class SimulationInfo extends Message<SimulationInfo> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * @generated from field: repeated vsmr.sm.v1.TaskInfo tasks = 2;
   */
  tasks: TaskInfo[] = [];

  constructor(data?: PartialMessage<SimulationInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SimulationInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tasks", kind: "message", T: TaskInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SimulationInfo {
    return new SimulationInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SimulationInfo {
    return new SimulationInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SimulationInfo {
    return new SimulationInfo().fromJsonString(jsonString, options);
  }

  static equals(a: SimulationInfo | PlainMessage<SimulationInfo> | undefined, b: SimulationInfo | PlainMessage<SimulationInfo> | undefined): boolean {
    return proto3.util.equals(SimulationInfo, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * SimulationInfoList
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.SimulationInfoList
 */
export class SimulationInfoList extends Message<SimulationInfoList> {
  /**
   * @generated from field: repeated vsmr.sm.v1.SimulationInfo simulations = 1;
   */
  simulations: SimulationInfo[] = [];

  constructor(data?: PartialMessage<SimulationInfoList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.SimulationInfoList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "simulations", kind: "message", T: SimulationInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SimulationInfoList {
    return new SimulationInfoList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SimulationInfoList {
    return new SimulationInfoList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SimulationInfoList {
    return new SimulationInfoList().fromJsonString(jsonString, options);
  }

  static equals(a: SimulationInfoList | PlainMessage<SimulationInfoList> | undefined, b: SimulationInfoList | PlainMessage<SimulationInfoList> | undefined): boolean {
    return proto3.util.equals(SimulationInfoList, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * TaskType
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.TaskType
 */
export class TaskType extends Message<TaskType> {
  /**
   * @generated from field: string task_type = 1;
   */
  taskType = "";

  constructor(data?: PartialMessage<TaskType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.TaskType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskType {
    return new TaskType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskType {
    return new TaskType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskType {
    return new TaskType().fromJsonString(jsonString, options);
  }

  static equals(a: TaskType | PlainMessage<TaskType> | undefined, b: TaskType | PlainMessage<TaskType> | undefined): boolean {
    return proto3.util.equals(TaskType, a, b);
  }
}

/**
 * ------------------------------------------------------------
 * TaskTypeList
 * ------------------------------------------------------------
 *
 * @generated from message vsmr.sm.v1.TaskTypeList
 */
export class TaskTypeList extends Message<TaskTypeList> {
  /**
   * @generated from field: repeated vsmr.sm.v1.TaskType task_types = 1;
   */
  taskTypes: TaskType[] = [];

  constructor(data?: PartialMessage<TaskTypeList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.sm.v1.TaskTypeList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_types", kind: "message", T: TaskType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskTypeList {
    return new TaskTypeList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskTypeList {
    return new TaskTypeList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskTypeList {
    return new TaskTypeList().fromJsonString(jsonString, options);
  }

  static equals(a: TaskTypeList | PlainMessage<TaskTypeList> | undefined, b: TaskTypeList | PlainMessage<TaskTypeList> | undefined): boolean {
    return proto3.util.equals(TaskTypeList, a, b);
  }
}

